import type { ReactNode } from 'react';
import * as styles from './ListItem.module.scss';

export function ListItem(props: { children: ReactNode }) {
    return <li className={styles.listItem}>{props.children}</li>;
}
